import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { Toast } from "../../atoms/Toast";
import { PopularPlaceForm, PopularPlaceFormData } from "../form/PopularPlaceForm";
import { usePopularPlaceEditing, usePopularPlacePage, usePopularPlaceToast } from "../../pages/popular_place/hook";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (data: PopularPlaceFormData) => void;
  defaultValues?: Partial<PopularPlaceFormData>;
  popularPlaceId?: string;
  refetchPopularPlaces?: () => void;
};

export const EditPopularPlaceModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  defaultValues,
  popularPlaceId,
  refetchPopularPlaces
}) => {
  const { toast, showToast, hideToast } = usePopularPlaceToast();
  const { handleEditPopularPlace } = usePopularPlaceEditing(showToast, refetchPopularPlaces, onClose);

  const handleFormSubmit = (data: PopularPlaceFormData, onError: (message: string) => void) => {
    if (!popularPlaceId) {
      onError('Popularplace ID is missing.');
      return;
    }
    handleEditPopularPlace(
      {
        name: data.name,
        name_kh: data.name_kh,
        name_zh: data.name_zh,
      },
      popularPlaceId,
      onError,
      () => {
        onSubmit?.(data);
      }
    );
  };

  if (!isOpen) return null;

  return (
    <div>
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
      <ModalTemplate
        isOpen={isOpen}
        title="Update Popular Place"
        onClose={onClose}
      >
        <PopularPlaceForm key={popularPlaceId} handleSubmit={handleFormSubmit} defaultValues={defaultValues} mode="edit" />
      </ModalTemplate>
    </div>
  );
};
